<template>
  <main class="list-view">
    <div id="g-contents">
      <div class="list-sub-menu" v-if="subType === 'general_list'">
        <div class="title">
          <h1 v-html="title" tabindex="0"></h1>
        </div>
      </div>
      <template v-if="hasCellList">
       <preview-cell-wrapper
          :cell-list="cellList"
          :thumbnail-info="thumbnailInfo"
       ></preview-cell-wrapper>
      </template>
      <template v-else-if="!hasCellList && !isLoading">
        <EmptyList></EmptyList>
      </template>
    </div>
  </main>
</template>
<script>
import _ from 'lodash'
import { mapMutations } from 'vuex'
import { parseUrl } from 'query-string'
import { SET_CURRENT_MENU } from '@/common/resources/const'
import { getThumbnailInfo, setDisableScrolling } from '@/common/utils/common'
import { apiRequest, applyQueryString } from '@/common/utils/request.common'
import { HTTP_METHOD_GET } from '@/common/utils/request.const'
import PreviewCellWrapper from '@/pages/list/commingsoon/PreviewCellWrapper'
import ListViewMixin from '@/mixins/listview.mixin'
import EmptyList from '@/pages/list/EmptyList'

export default {
  name: 'InstantPlayerIndex',
  components: {
    PreviewCellWrapper,
    EmptyList
  },
  mixins: [ListViewMixin],
  data () {
    return {
      isLoading: true,
      thumbnailInfo: null,
      uiCode: null,
      url: null,
      query: null,
      currentPage: 1,
      limit: 50,
      titleList: [],
      subType: '',
      topButtonList: []
    }
  },
  computed: {
    hasCellList () {
      return this.cellList.length > 0
    }
  },
  methods: {
    ...mapMutations([SET_CURRENT_MENU]),
    setData () {
      this.isLoading = true
      const CELL_TYPE_PATH = ['cell_toplist', 'cell_type']
      const setTitleList = data => { this.titleList = _.get(data, ['cell_toplist', 'title_list'], []); return data }
      const setSubTitle = data => { this.subType = _.get(data, 'sub_type', ''); return data }
      const setTopButtonList = data => { this.topButtonList = _.get(data, ['cell_toplist', 'topbuttonlist'], []); return data }
      const setThumbnailInfo = data => { this.thumbnailInfo = getThumbnailInfo(_.get(data, CELL_TYPE_PATH, '')); return data }
      const scrollToTop = () => { window.scrollTo(0, 0) }
      const loadComplete = () => { this.isLoading = false }
      const assignedQuery = Object.assign({}, this.query)
      delete assignedQuery.api
      assignedQuery.limit = 50
      const req = { url: applyQueryString(`https://${this.url}`, assignedQuery), method: HTTP_METHOD_GET }
      const logger = data => { console.log(data); return data }

      apiRequest(req)
        .then(this.getData)
        .then(logger)
        .then(this.setTitle)
        // .then(this.setFilter)
        .then(setTitleList)
        .then(setTopButtonList)
        .then(setSubTitle)
        .then(this.setCellType)
        .then(setThumbnailInfo)
        .then(this.clearCellList)
        .then(this.setCellList)
        .then(scrollToTop)
        .then(loadComplete)
      .then(() => {
        console.log('thumbnailInfo : ', this.thumbnailInfo)
        console.log('subType :', this.subType)
      })
    },
    async initialize () {
      const { url, query } = parseUrl(decodeURIComponent(_.get(this.$route, 'query.api', '')))
      this.url = url
      this.query = query
      this.setData()
    },
    setCurrentMenu () {
      const menu = _.get(this.$route, ['query', 'came'], '')
      this[SET_CURRENT_MENU](menu)
    }
  },
  created () {
    setDisableScrolling(false)
    this.setCurrentMenu()
    this.initialize()
  },
  watch: {
    $route (newRoute, oldRoute) {
      const routeQuery = _.get(newRoute, 'query', {})
      this.updateQuery(routeQuery)
      this.initialize()
    }
  }
}
</script>
